import { render, staticRenderFns } from "./UpdateVoyage.vue?vue&type=template&id=33e12473&"
import script from "./UpdateVoyage.vue?vue&type=script&lang=js&"
export * from "./UpdateVoyage.vue?vue&type=script&lang=js&"
import style0 from "./UpdateVoyage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports